export const mockDiscountContent = {
  banner:
    'Online exclusive offer – get Appliance Care with {{ percentage }} off! Limited time only',
  subscription: 'Offer - {{ percentage }} off for first {{ term }} months',
  prepay:
    'Offer - {{ percentage }} off for first {{ term }} months, pay annually',
  discountCode: 'D20PTM',
};
